<template>
    <div>
        <template v-if="isShow">
            <div class="back" @click="doBackfuyu" v-if="appTag==1">确认并返回</div>
            <div class="back" @click="doBackjft" v-if="appTag==0">确认并返回</div>
            <div class="back" @click="doBackdzpay" v-if="appTag==2">确认并返回</div>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                tradeNO: '',
                appTag:'',
                isShow:false,//判断是否为安卓
                res:null,
            }
        },
        created () {
            document.title="支付";
            let tradeNO = this.$route.query.tradeNO;
            let appTag = this.$route.query.appTag;//0 佳付通 1 富裕钱包
            if(!!tradeNO){
                this.tradeNO = tradeNO;
            }
            if(!!appTag){
                this.appTag = appTag;
            }
            this.doJump();
        },
        methods: {
            doJump() {
                let that = this;
                ap.tradePay({
                    tradeNO: this.tradeNO//后端返回的支付宝订单号
                }, function(res){
                    var ua = navigator.userAgent;
                    var isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                    //如果是苹果系统
                    if(isiOS){
                        if(that.appTag == 1){
                            window.location.href = 'https://oem-client.verajft.com/fuyu?resultCode='+res.resultCode;
                        }else if(that.appTag == 0){
                            window.location.href = 'https://oem-client.verajft.com/hksht?resultCode='+res.resultCode;
                        }else{
                            window.location.href = 'https://oem-client.verajft.com/dzpay?resultCode='+res.resultCode;
                        }
                    }else{//如果是安卓系统
                        that.isShow = true;
                        that.res = res;
                    }
                });
            },
            //回跳富裕钱包APP
            doBackfuyu(){
                window.location.href='caishilive://oemclient/fuyu?resultCode='+this.res.resultCode;
            },
            //回跳商户通APP
            doBackjft(){
                window.location.href='caishilive://oemclient/mxkpay?resultCode='+this.res.resultCode;
            },
            //回跳我是队长APP
            doBackdzpay(){
                window.location.href='caishilive://oemclient/dzpay?resultCode='+this.res.resultCode;
            },
        },
    }
</script>

<style lang="scss" scoped>
.back{
    background: #2069FF;
    height: 48px;
    line-height: 48px;
    color: #fff;
    border-radius: 4px;
    text-align: center;
    font-size: 16px;
    margin: 50% 15px 0;
}
</style>